import { SideBar } from "components/sideBar/sideBar.component";
import style from './sideMenu.module.css'
import Logo from 'assets/images/ARO Tech - logo vetor.png'
import { MenuItem } from "./menuItem.component";
import { View } from "components/view/view.component";
import { Image } from "components/image/image.component";
import { useAuth } from "services/auth.service";
import { FEATURE } from "data/features.data";
import { useGetCompanyIndicatorsApi } from "api/company.api";
import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useGetMenuConfig } from "api/config.api";

type SideMenuProps = {
    open?: boolean
}

export function SideMenu({open}:SideMenuProps){

    const {featuresAllowed} = useAuth()
    const {companyId} = useParams()
    const {get: getIndicators, data: indicatorsApi} = useGetCompanyIndicatorsApi(companyId ?? '')
    const {get: getMenuConfig, data: menuConfig} = useGetMenuConfig(companyId ?? '')

    const reports: {id: string, title: string, link: string}[] | undefined = menuConfig?.reports?.map(_ => {return {id: _.id, title: _.name, link: companyId ? `/${companyId}/relatorio/${_.id}`: `/relatorio/${_.id}` }})
    ?? []

    const graphics: {id: string, title: string, link: string}[] | undefined = menuConfig?.graphics?.map(_ => {return {id: _.id, title: _.name, link: companyId ? `/${companyId}/grafico/${_.id}`: `/grafico/${_.id}` }})
    ?? []

    const dashboards: {id: string, title: string, link: string, features?: string[]}[] | undefined = menuConfig?.dashboards?.map(_ => {return {id: _.id, title: _.name, features: _.features ? _.features :[FEATURE.DASHBOARD_VIEW.id], link: companyId ? `/${companyId}/dashboard/${_.id}`: `/dashboard/${_.id}` }}).sort((a,b) => a.title.localeCompare(b.title))
    ?? []

    const canViewDashboards = dashboards.length > 0
        ? dashboards.some(dashboard => featuresAllowed(dashboard.features))
        : featuresAllowed([FEATURE.DASHBOARD_VIEW.id])

    const inputIndicators: {id: string, title: string, link: string}[] | undefined = indicatorsApi?.inputIndicators
    ? indicatorsApi.inputIndicators.map(_ => {return{id: _.id, title: _.name, link: `/${companyId}/cadastros/${_.id}`}}).sort((a,b) => a.title.localeCompare(b.title))
    : []

    const noInputIndicators = inputIndicators?.length === 0

    // const reportIndicators: {id: string, title: string, link: string}[] | undefined = indicatorsApi?.reportIndicators
    // ? indicatorsApi.reportIndicators.map(_ => {return{id: _.id, title: _.name, link: `/${companyId}/relatorio/${_.id}`}})
    // : []

    const graphicIndicators: {id: string, title: string, link: string}[] | undefined = indicatorsApi?.graphicIndicators
    ? indicatorsApi.graphicIndicators.map(_ => {return{id: _.id, title: _.name, link: `/${companyId}/grafico/${_.id}`}}).sort((a,b) => a.title.localeCompare(b.title))
    : []

    let graphicSubItems = graphics
    if(graphics && graphics.length === 1 && graphics.map(_ => _.id).includes('indicadores')) graphicSubItems = graphicIndicators

    useEffect(() => {
        getIndicators().catch(error=>{console.log(`Indicators error:`, error.message)})
        getMenuConfig().catch(error=>{console.log(`Indicators error:`, error.message)})
    // eslint-disable-next-line
    }, [])

    function handleItemClick(id: string){

    }

    return <SideBar open={open} >
        <View className={style.MenuContent}>
            <a href="/">
                <View className={style.Header}>
                    <Image className={style.LogoImage} src={Logo} alt="Logo Aro Tech" />
                </View>
            </a>
            <View className={style.Content}>
                {/* {menuItems.map(_ =>  <MenuItem hide={_.features ? !featuresAllowed(_.features) : false} key={_.id} id={_.id} iconName={_.icon} text={_.title} link={_.link} onClick={handleItemClick} subItems={_.subItems}/> )} */}
                {/* <MenuItem id={'home'} iconName={'home'} text={'Home'} link={companyId ? `/${companyId}` :'/'} onClick={handleItemClick} /> */}
                <MenuItem hide={!canViewDashboards} id={'dashboard'} iconName={'dashboard'} text={dashboards.length === 1 ? 'Dashboard' : 'Dashboards'} link={dashboards.length === 1 ? dashboards[0].link : undefined} onClick={handleItemClick} subItems={dashboards.length > 1 ? dashboards : undefined} />
                <MenuItem hide={!featuresAllowed([FEATURE.CHART_VIEW.id])} key={'charts'} id={'charts'} iconName={'bar_chart'} text={'Gráficos'} onClick={handleItemClick} subItems={graphicSubItems} link={graphics?.length === 1 ? graphics[0].link : undefined}/>
                <MenuItem hide={!featuresAllowed([FEATURE.REPORT_VIEW.id])} key={'reports'} id={'reports'} iconName={'description'} text={'Relatórios'} onClick={handleItemClick} link={reports?.length === 1 ? reports[0].link : undefined} subItems={reports.length > 1 ? reports : undefined}/>
                <MenuItem hide={(!featuresAllowed([FEATURE.INDICATOR_RECORD_LIST.id]) || noInputIndicators)} key={'data'} id={'data'} iconName={'table'} text={'Dados Cadastrais'} onClick={handleItemClick} subItems={inputIndicators}/>
                <MenuItem hide={!featuresAllowed([FEATURE.USER_LIST.id])} key={'users'} id={'users'} iconName={'group'} text={'Usuários'} link={companyId ? `/${companyId}/usuarios` :'/usuarios'} onClick={handleItemClick} />
                <MenuItem hide={!featuresAllowed([FEATURE.BUILDING_GROUP_LIST.id]) } key={'groups'} id={'groups'} iconName={'lan'} text={'Grupos de Prédios'} link={companyId ? `/${companyId}/grupos-de-predios` :'/grupos-de-predios'} onClick={handleItemClick} />
                <MenuItem hide={!featuresAllowed([FEATURE.BUILDING_LIST.id]) } key={'buildings'} id={'buildings'} iconName={'domain'} text={'Prédios'} link={companyId ? `/${companyId}/predios` :'/predios'} onClick={handleItemClick} />
                <MenuItem hide={!featuresAllowed([FEATURE.BUILDING_LIST.id]) } key={'areas'} id={'areas'} iconName={'floor'} text={'Andares'} link={companyId ? `/${companyId}/andares` :'/andares'} onClick={handleItemClick} />
                <MenuItem hide={!featuresAllowed([FEATURE.BUILDING_LIST.id]) } key={'rooms'} id={'rooms'} iconName={'meeting_room'} text={'Salas'} link={companyId ? `/${companyId}/salas` :'/salas'} onClick={handleItemClick} />
                <MenuItem hide={!featuresAllowed([FEATURE.PENDING_RECORDS_LIST.id])} key={'peding-records'} id={'pending-records'} iconName={'sync_problem'} text="Pendência de Lançamentos" link={companyId ? `/${companyId}/pendencia-lancamentos` :'/pendencia-lancamentos'} />
                <MenuItem hide={!featuresAllowed([FEATURE.ALERT_LIST.id])} key={'alerts'} id={'alerts'} iconName={'flag'} text="Alertas" link={companyId ? `/${companyId}/alertas` :'/alertas'} />
                <MenuItem hide={!featuresAllowed([FEATURE.CONFIG_ALERT_LIST.id])} key={'config-alerts'} id={'config-alerts'} iconName={'flag_circle'} text="Configurações de Alertas" link={companyId ? `/${companyId}/config-alertas` :'/config-alertas'} />
                <MenuItem hide={!featuresAllowed([FEATURE.LOGS_LIST.id]) } key={'logs'} id={'logs'} iconName={'lists'} text={'Logs de Indicadores'} link={companyId ? `/${companyId}/logs` :'/logs'} onClick={handleItemClick} />
                <MenuItem hide={!featuresAllowed([FEATURE.COMPANY_LIST.id]) } key={'companies'} id={'companies'} iconName={'handshake'} text={'Empresas'} link={companyId ? `/${companyId}/empresas` :'/empresas'} onClick={handleItemClick} />
            </View>
            <View className={style.Footer}>

            </View>
        </View>
    </SideBar>
}